"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectOptions = exports.deselectOptions = void 0;

var _dom = require("@testing-library/dom");

var _utils = require("./utils");

var _click = require("./click");

var _focus = require("./focus");

var _hover = require("./hover");

function selectOptionsBase(newValue, select, values, init) {
  var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref$skipPointerEvent = _ref.skipPointerEventsCheck,
      skipPointerEventsCheck = _ref$skipPointerEvent === void 0 ? false : _ref$skipPointerEvent;

  if (!newValue && !select.multiple) {
    throw (0, _dom.getConfig)().getElementError("Unable to deselect an option in a non-multiple select. Use selectOptions to change the selection instead.", select);
  }

  var valArray = Array.isArray(values) ? values : [values];
  var allOptions = Array.from(select.querySelectorAll('option, [role="option"]'));
  var selectedOptions = valArray.map(function (val) {
    if (typeof val !== 'string' && allOptions.includes(val)) {
      return val;
    } else {
      var matchingOption = allOptions.find(function (o) {
        return o.value === val || o.innerHTML === val;
      });

      if (matchingOption) {
        return matchingOption;
      } else {
        throw (0, _dom.getConfig)().getElementError("Value \"".concat(String(val), "\" not found in options"), select);
      }
    }
  }).filter(function (option) {
    return !(0, _utils.isDisabled)(option);
  });
  if ((0, _utils.isDisabled)(select) || !selectedOptions.length) return;

  if ((0, _utils.isElementType)(select, 'select')) {
    if (select.multiple) {
      var _iterator = _createForOfIteratorHelper(selectedOptions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;
          var withPointerEvents = skipPointerEventsCheck ? true : (0, _utils.hasPointerEvents)(option); // events fired for multiple select are weird. Can't use hover...

          if (withPointerEvents) {
            _dom.fireEvent.pointerOver(option, init);

            _dom.fireEvent.pointerEnter(select, init);

            _dom.fireEvent.mouseOver(option);

            _dom.fireEvent.mouseEnter(select);

            _dom.fireEvent.pointerMove(option, init);

            _dom.fireEvent.mouseMove(option, init);

            _dom.fireEvent.pointerDown(option, init);

            _dom.fireEvent.mouseDown(option, init);
          }

          (0, _focus.focus)(select);

          if (withPointerEvents) {
            _dom.fireEvent.pointerUp(option, init);

            _dom.fireEvent.mouseUp(option, init);
          }

          selectOption(option);

          if (withPointerEvents) {
            _dom.fireEvent.click(option, init);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else if (selectedOptions.length === 1) {
      var _withPointerEvents = skipPointerEventsCheck ? true : (0, _utils.hasPointerEvents)(select); // the click to open the select options


      if (_withPointerEvents) {
        (0, _click.click)(select, init, {
          skipPointerEventsCheck: skipPointerEventsCheck
        });
      } else {
        (0, _focus.focus)(select);
      }

      selectOption(selectedOptions[0]);

      if (_withPointerEvents) {
        // the browser triggers another click event on the select for the click on the option
        // this second click has no 'down' phase
        _dom.fireEvent.pointerOver(select, init);

        _dom.fireEvent.pointerEnter(select, init);

        _dom.fireEvent.mouseOver(select);

        _dom.fireEvent.mouseEnter(select);

        _dom.fireEvent.pointerUp(select, init);

        _dom.fireEvent.mouseUp(select, init);

        _dom.fireEvent.click(select, init);
      }
    } else {
      throw (0, _dom.getConfig)().getElementError("Cannot select multiple options on a non-multiple select", select);
    }
  } else if (select.getAttribute('role') === 'listbox') {
    selectedOptions.forEach(function (option) {
      (0, _hover.hover)(option, init, {
        skipPointerEventsCheck: skipPointerEventsCheck
      });
      (0, _click.click)(option, init, {
        skipPointerEventsCheck: skipPointerEventsCheck
      });
      (0, _hover.unhover)(option, init, {
        skipPointerEventsCheck: skipPointerEventsCheck
      });
    });
  } else {
    throw (0, _dom.getConfig)().getElementError("Cannot select options on elements that are neither select nor listbox elements", select);
  }

  function selectOption(option) {
    option.selected = newValue;
    (0, _dom.fireEvent)(select, (0, _dom.createEvent)('input', select, _objectSpread({
      bubbles: true,
      cancelable: false,
      composed: true
    }, init)));

    _dom.fireEvent.change(select, init);
  }
}

var selectOptions = selectOptionsBase.bind(null, true);
exports.selectOptions = selectOptions;
var deselectOptions = selectOptionsBase.bind(null, false);
exports.deselectOptions = deselectOptions;